module.exports = __webpack_public_path__ + "static/media/031-file-sharing-2.6ab3709b.svg";